import React from 'react';
import cl from './Footer.module.css';
import { NavLink } from 'react-router-dom';

const Footer = (props) => {
  return (
    <footer className={cl.app_footer}>
      <div className={cl.app_footer_main}>
        <div className={cl.app_footer_logolinks}>
          <div className={cl.middle_line_logo}>
            <h1>{props.shopName}</h1>
          </div>
          <h1>Pages</h1>
          <NavLink className={cl.footer_link} to="">
            Home
          </NavLink>
          <NavLink className={cl.footer_link} to="/about">
            About
          </NavLink>
          {/* <NavLink className = { cl.footer_link } to='/news'>News</NavLink> */}
          <NavLink className={cl.footer_link} to="/products">
            Products
          </NavLink>
          <NavLink className={cl.footer_link} to="/contacts">
            Contacts
          </NavLink>
        </div>
        <div className={cl.app_footer_links}>
          <h1>References</h1>
          <NavLink className={cl.footer_link} to="/policy">
            Privacy policy
          </NavLink>
          <NavLink className={cl.footer_link} to="/terms">
            Terms of service
          </NavLink>
          <NavLink className={cl.footer_link} to="/refund-policy">
            Refund Policy
          </NavLink>
          <NavLink className={cl.footer_link} to="/shipping-policy">
            Shipping Policy
          </NavLink>
          <NavLink className={cl.footer_link} to="/cookies-policy ">
            Cookies Policy
          </NavLink>
        </div>
        <div className={cl.app_footer_info}>
          <h2>WE ACCEPT</h2>
          <img
            src="https://cdn.icon-icons.com/icons2/1186/PNG/512/1490135017-visa_82256.png"
            alt="Visa"
          />
          <img
            src="https://www.iconarchive.com/download/i76278/designbolts/credit-card-payment/Master-Card.ico"
            alt="Master Card"
          />
        </div>
        <div className={cl.app_footer_info}>
          <h2>WE WANT TO HEAR YOUR VOICE</h2>
          <p>
            Our company was established in 2012 with only 3 employees. Over the
            years, perfectturn has more than 500,000 satisfied customers. It's
            important that we continue to deliver amazing products to our best
            customers, each of which includes customer service via phone, text
            and email. We look forward to growing with you!
          </p>
        </div>
      </div>
      <div className={cl.app_footer_bottom_line}>
        <p>Copyright 2023 {props.shopName}</p>
      </div>
    </footer>
  );
};

export default Footer;
